
import request from '@/utils/request'

/** 获取资源详情 */
export function getListResourceInfo(params) {
  return request({
    url:'/productResource/web/listResourceInfo',
    method:'get',
    params:params,
  })
}

/** 根据商品编码获取商品信息 */
export function getFindByCodeInfo(params,data) {
  return request({
    url:'/product/web/findByCode',
    method:'post',
    params:params,
    data:data
  })
}
export function applyAudit(params,data) {
    return request({
      url:'/teacherApplyTrial/web/save',
      method:'post',
      params:params,
      data:data
    })
  }
/** 获取推荐数据 */
export function pageProductRecom(params){
  return request({
    url:'/productRecom/web/pageProductRecom',
    method:'get',
    params: params
  })
}

/** 查询模块列表 */
export function getModuleList(params){
  return request({
    url:'/module/web/list',
    method:'get',
    params: params
  })
}

/** 获取产品详情（模块详情） */
export function getModuleInfo(params){
  return request({
    url:'/module/web/moduleInfo',
    method:'get',
    params: params
  })
}

/** 公开课产品列表 */
export function openLiveCourseModuleList(params,data) {
  return request({
    url:'/module/web/openLiveCourseModuleList',
    method:'post',
    params:params,
    data:data
  })
}

/** 获取公开课报名情况 */
export function getModuleLiveProductSignInfo(params,data) {
  return request({
    url:'/product/web/getModuleLiveProductSignInfo',
    method:'post',
    params:params,
    data:data
  })
}

/** 获得最近的公开课和历史公开课列表 */
export function getOpenClassList(params,data) {
  return request({
    url:'/module/web/openLiveCourseModuleListByTime',
    method:'post',
    params:params,
    data:data
  })
}

/** 报名公开课 */
export function signUpPublicLive(params,data) {
  return request({
    url:'/userResource/web/signUpPublicLive',
    method:'post',
    params:params,
    data:data
  })
}

/** 根据商品列表 */
export function getProductPage(params,data) {
  return request({
    url:'/product/web/PageIndexProduct',
    method:'post',
    params:params,
    data:data
  })
}

/** 获取新闻列表 */
export function cabpInfomationList (params,data) {
  return request({
    url: '/cabpInfomation/web/page',
    method: 'post',
    params:params,
    data:data
  })
}

/** banner */
export function getBannerList(params) {
  return request({
    url:'/banner/findListByCode',
    method:'get',
    params:params
  })
}

/** 获取商品类型 */
export function productCategorys (params,data) {
  return request({
    url:'/product/web/productCategorys',
    method: 'post',
    params: params,
    data: data
  })
}

/** 获取商品类型下专业 */
export function productCategoryType (params) {
  return request({
    url:'/categoryType/web/productCategoryType',
    methods: 'get',
    params: params
  })
}

/** 获取某模块下的产品列表（此处的产品就是子模块） */
export function moduleProduct (params) {
  return request({
    url:'/module/web/findChilds',
    methods: 'get',
    params: params
  })
}

/** 获取专业分类 */
export function categoryType(params) {
  return request({
    url: '/categoryType/web/list',
    method: 'get',
    params: params
  })
}

/** 榜单 */
export function readCountList(params,data) {
  return request({
    url:'/product/web/readCountList',
    method:'post',
    params:params,
    data:data
  })
}

/** 模块详情 */
export function moduleInfo(params){
  return request({
    url:'/module/info',
    method:'get',
    params:params
  })
}
/**用户评价 */
export function getUserCommont(params) {
  return request({
    url:'/productComment/web/page',
    method:'get',
    params:params,
    data:data
  })
}
/**目录数据 */
export function getResCatalogs(params) {
  return request({
    url:'/resource/web/resCatalogs',
    method:'get',
    params:params
  })
}
/**pdf目录数据 */
export function getResCatalogsPDF(params) {
  return request({
    url:'/resource/web/pdfResCatalogs',
    method:'get',
    params:params,
    data:data
  })
}
/**我的足迹 */
export function getBrowseRecord(params) {
  return request({
    url:'/browseRecord/web/page',
    method:'get',
    params:params,
  })
}
/**相关推荐 */
export function getProductRecomList(params) {
  return request({
    url:'/productRecom/web/productRecomList',
    method:'get',
    params:params,
    // data:data
  })
}

/**加入购物车 */
export function addShoppingCart(params,data) {
  return request({
    url:'/shoppingCart/web/save',
    method:'post',
    params:params,
    data:data
  })
}

/**产品多选批量加入购物车 */
export function addShoppingCartAll(params,data) {
  return request({
    url:'/shoppingCart/web/batSave',
    method:'post',
    params:params,
    data:data
  })
}

/**微信参数请求 */
export function wxMiniPay(params,data) {
  return request({
    url:'/onlinePay/web/wxMiniPay',
    method:'post',
    params:params,
    data:data
  })
}

/**更新收货地址 */
export function updateByAddressId(params,data) {
  return request({
    url:'/UserAddress/updateByAddressId',
    method:'post',
    params:params,
    data:data
  })
}

/**设置默认收货地址 */
export function UserAddressDefault(params,data) {
  return request({
    url:'/UserAddress/isDefault',
    method:'post',
    params:params,
    data:data
  })
}
/**查询收货地址信息 */
export function selectUserAddressByAddressID(params,data) {
  return request({
    url:'/UserAddress/selectUserAddressByAddressID',
    method:'post',
    params:params,
    data:data
  })
}
/**删除收货地址 */
export function delectUserAddressByAddressId(params,data) {
  return request({
    url:'/UserAddress/delectUserAddressByAddressId',
    method:'post',
    params:params,
    data:data
  })
}

/**获取城市数据 */
export function selectRegion(params,data) {
  return request({
    url:'/region/selectRegion',
    method:'post',
    params:params,
    data:data
  })
}

/**获取用户城市地址 */
export function findRegion(params,data) {
  return request({
    url:'/region/findRegion',
    method:'post',
    params:params,
    data:data
  })
}

/**获取商品圈子列表 */
export function circleByCode(params,data) {
  return request({
    url:'/circle/web/circleByCode',
    method:'post',
    params:params,
    data:data
  })
}
/** circleList */

/**圈子邀请码加入请求 */
export function joinCircle(params,data) {
  return request({
    url:'/inviteCode/web/exchange',
    method:'post',
    params:params,
    data:data
  })
}

/**用户收藏/取消收藏 */
export function collectProductAsyncSend(params,data) {
  return request({
    url:'/collectProduct/web/asyncSend',
    method:'post',
    params:params,
    data:data
  })
}

/**商品关联增值包 */
export function productPackageWebPage(params,data) {
  /**不分页 */
  return request({
    url:'/productPackage/web/list',
    method:'post',
    params:params,
    data:data
  })
}

/**课件下载请求 */
export function resourceDownload(params) {
  return request({
    url:'/resource/web/download',
    method:'get',
    params:params,
    // data:data
  })
}

/**搜索全文 */
export function searchGroupResource(params,data) {
  return request({
    url:'/search/web/searchGroupResResource',
    method:'post',
    params:params,
    data:data
  })
}

/** 根据圈子名称搜索 */
export function pageCircle(params,data){
  return request({
    url: '/circle/web/pageCircle',
    method: 'post',
    params: params,
    data: data
  })
}

/**根据评论搜索圈子 */
export function searchComment(params,data){
  return request({
    url: '/search/web/searchComment',
    method: 'post',
    params: params,
    data: data
  })
}


/** 根据内容搜索圈子 */
export function contentCircle(params){
  return request({
    url:'/resource/web/circleSearch',
    method: 'get',
    params: params
  })
}

/** 高级搜索 */
export function advancedSearch(params,data){
  return request({
    url:'/productResource/web/advancedSearch',
    method: 'post',
    params: params,
    data: data
  })
}

/**h5搜索分类数据获取 */
export function getSaleClass(params) {
  return request({
    url:'/saleClass/list',
    method:'get',
    params:params
  })
}

/** 根据平台、模块、品种 获取上架的商品的销售分类列表 */
export function productSaleClass(params){
  return request({
    url: '/product/web/productSaleClass',
    method:'get',
    params:params
  })
}

/**根据销售分类code获取销售分类详情 */
//  saleclassCode

export function saleClassInfo (params){
  return request({
    url: '/saleClass/info',
    method:'get',
    params: params
  })
}

/**热词搜索 */
export function getHotKeyWords(params) {
  return request({
    url:'/searchLog/hotKeyWords',
    method:'get',
    params:params,
    data:data
  })
}

/**专题库 */
export function getModuleProducts(params,data){
  return request({
    url:'/product/web/moduleProducts',
    method:'post',
    params:params,
    data:data
  })
}



/**签到 */
export function getSignIn(params,data){
  return request({
    url:'/userAccumulate/web/signIn',
    method:'post',
    params:params,
    data:data
  })
}
/**用户获取积分以及今日积分任务完成记录 */
export function getUserAccounment(params,data){
  return request({
    url:'/userAccumulate/web/findByToken',
    method:'post',
    params:params,
    data:data
  })
}
/** 根据社书号查询商品库存 */

export function selectByCabpno(params) {
  return request({
    url:'/inventory/web/selectByCabpno',
    method:'get',
    params:params
  })
}

export function getResourceAffiliate(params) {
  return request({
    url:'/resourceAffiliate/web/list',
    method:'get',
    params:params
  })
}

/** 区域 */
export function resCatalogData(params){
  return request({
    url: '/region/selectRegion',
    method: 'post',
    params: params
  })
}

/** 样书申请---保存 */
export function sampleBookSave(params,data){
  return request({
    url: '/sampleBook/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

/**书单 */
export function getPageList(params,data){
  return request({
    url:'/book/web/pageList',
    method:'post',
    params:params,
    data:data
  })
}
export function getExportBooks(params){
  return request({
    url:'/book/web/exportBooks',
    method:'get',
    params:params,
    timeout: 1000*120,
  })
}

/** 前台兑换 */
export function redeem(params,data){
  return request({
    url: '/productRedeem/web/redeem',
    method: 'post',
    params: params,
    data: data
  })
}

/** 获取新闻详情 */
export function cabpInfomationInfo (params) {
    return request({
      url: '/cabpInfomation/web/findById',
      method: 'get',
      params: params
    })
  }

/** 添加用户访问日志 */

export function asyncSave (params,data) {
  return request({
    url: '/visitLog/web/asyncSave',
    method: 'post',
    params: params,
    data: data
  })
}


/** 获取专家列表 */
export function newExpert (params,data) {
 return request({
   url: '/expert/web/webPageExpert',
   method: 'post',
   params: params,
   data: data
 })
}


/** 获取专家详情 */
export function findExpertById (params,data) {
  return request({
    url: '/expert/web/findById',
    method: 'post',
    params: params,
    data: data
  })
 }


 /** 作家品种列表 */
export function expertCategList (params,data) {
  return request({
    url: '/expertProduct/web/catagroys',
    method: 'post',
    params: params,
    data: data
  })
}


 /** 作家作品列表 */
 export function expertProduct (params,data) {
  return request({
    url: '/expertProduct/web/webSelect',
    method: 'post',
    params: params,
    data: data
  })
}


/** 按商品代码查证增值服务包的商品和目录信息 */
export function getProductByProductCode (params) {
  return request({
    url: '/productPackageRelation/web/getProductByProductCode',
    method: 'get',
    params: params
  })
}

/** 获取目录下的资源商品价格权限信息 */
export function packageResource (params) {
  return request({
    url: '/resourceAffiliate/web/packageResource',
    method: 'get',
    params: params
  })
}

/** 前台获取字典列表 */

export function cabpDicList (params,data) {
  return request({
    url: '/cabpDic/web/list',
    method: 'post',
    params: params,
    data: data
  })
}
/** 获得产品下的商品购买情况 */
export function getModuleProductInfo (params) {
  return request({
    url: '/product/web/getModuleProductInfo',
    method: 'get',
    params: params
  })
}

/** 收藏产品（收藏模块） */
export function getCollectModule (params,data) {
  return request({
    url: '/module/web/collectModule',
    method: 'post',
    params: params,
    data: data
  })
}

/** 通过商品编码获取新闻详情 */
export function getfindByPorductCode (params) {
  return request({
    url: '/cabpInfomation/web/findByPorductCode',
    method: 'get',
    params: params
  })
}

/** 按渠道码的实际链接查询商品信息 */
export function getselectByQrUrl (params) {
  return request({
    url: '/productPackageRelation/web/selectByQrUrl',
    method: 'get',
    params: params
  })
}

/** 活的直播课信息权限  下载讲义 */
export function liveCourseware (params) {
  return request({
    url: '/liveCourse/web/getLiveAuthority',
    methods: 'get',
    params: params
  })
}
/** 直播相关的权限 */
// productCode
// resourceCabpid
export function getLiveAuthority (params) {
    return request({
      url: '/liveCourse/web/getLiveAuthority',
      method: 'get',
      params: params
    })
  }

/** 添加扫码日志 */
export function getScanLog(params,data){
  return request ({
    url:'/scanLog/web/asyncSave',
    method: 'post',
    params: params,
    data:data
  })
}
  //获取期刊的年份
  export function groupJournalYears (params,data) {
    return request({
      url: '/journal/web/groupJournalYears',
      method: 'post',
      params: params,
      data: data
    })
  }
  //出版年份下的期刊列表
  export function yearsJournal (params,data) {
    return request({
      url: '/journal/web/yearsJournal',
      method: 'post',
      params: params,
      data: data
    })
  }
  //分页查询文章栏目
  export function groupArticlsColumns (params,data) {
    return request({
      url: '/journal/web/groupArticlsColumns',
      method: 'post',
      params: params,
      data: data
    })
  }
  //分页查询期刊/栏目 下的文章
  export function journalsArticl (params,data) {
    return request({
      url: '/journal/web/journalsArticl',
      method: 'post',
      params: params,
      data: data
    })
  }
  ///journal/web/articlSearchType 关键词命中
  export function articlSearchType (params,data) {
    return request({
      url: '/journal/web/articlSearchType',
      method: 'post',
      params: params,
      data: data
    })
  }

  /** 加入班级 */
  export function joinClass (params,data) {
    return request({
      url: '/student/web/joinClass',
      method: 'post',
      params:params,
      data: data
    })
  }
  /** 教师建课 */
  export function creatCourse (params,data) {
    return request({
      url: '/tbCourse/web/teacher/save',
      method: 'post',
      params: params,
      data: data
    })
  }
   /** 教师建课 */
   export function BookApply (params,data) {
    return request({
      url: '/teacherBookApply/web/save',
      method: 'post',
      params: params,
      data: data
    })
  }
  // 获取活动类型
  export function salePromotionList (params) {
    return request({
        url: '/salePromotion/web/salePromotionList',
        method: 'get',
        params: params,
    })
  }
  // 根据活动id获取活动信息
  export function findPromotionById (params) {
    return request({
        url: '/salePromotion/web/findPromotionById',
        method: 'get',
        params: params,
    })
  }
   // 根据活动id获取活动分类
   export function saleClassBypId (params) {
       return request({
           url: '/saleClass/web/saleClassBypId',
           method: 'get',
           params: params,
       })
   }
   // 相关纸书分页列表
   export function pageRelatedPaperBooks (params) {
    return request({
        url: '/productRecom/web/pageRelatedPaperBooks',
        method: 'get',
        params: params,
    })
}
/** 微信分享 */
export function getVxShareSign(params,data) {
  return request({
    url:'/thildlogin/getVxShareSign',
    method:'post',
    params:params,
    data:data
  })
}

/** 用户查询自己的教师认证信息 */
export function findMyTeacherApplyTrial(params,data) {
  return request({
    url:'/teacherApplyTrial/web/findMyTeacherApplyTrial',
    method:'post',
    params:params,
    data:data
  })
}

/** 商品赠书分页列表 */
export function getGiftPageList(params,data) {
  return request({
    url:'/productGift/web/getGiftPageList',
    method:'post',
    params:params,
    data:data
  })
}

/** 获取商品精图 */
export function getProductFinePicture(params) {
  return request({
    url:'/product/web/getProductFinePicture',
    method:'get',
    params:params
  })
}


// WEBPACK FOOTER //
// ./src/api/publishOnline.js